import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PaymentVerification } from '../../models/payment-verification';
import { CommonModule } from '@angular/common';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { MessagesModule } from 'primeng/messages';
import { Message, MessageService } from 'primeng/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { mapToVerifyPayment } from '../../utilities/payment-verification';
import { PaymentVerificationsService } from '../../service/payment-verifications.service';
import { Router } from '@angular/router';
import { languages } from '../../constants/languages';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../service/language.service';
import { NgxTranslateModule } from 'src/app/translate.module';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-payment-verification-confirm',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextareaModule,
        ButtonModule,
        CalendarModule,
        NgxTranslateModule,
        ToastModule,
        InputTextareaModule,
        CheckboxModule,
        InputTextModule,
        CardModule,
        MessagesModule,
    ],
    templateUrl: './payment-verification-confirm.component.html',
    styleUrl: './payment-verification-confirm.component.scss',
    providers: [MessageService],
})
export class PaymentVerificationConfirmComponent {
    action!: string;
    verificationDetail!: PaymentVerification;
    confirmForm!: FormGroup;
    messages: Message[] = [];
    minDate!: Date;
    maxDate = new Date();
    pageTitle!: string;

    languages: any[] = languages;
    selectedLanguage!: string;

    loadingPOP: boolean = false;

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private fb: FormBuilder,
        private translateService: TranslateService,
        private languageService: LanguageService,
        private verificationsService: PaymentVerificationsService,
        private messageService: MessageService,
        private router: Router
    ) {
        this.action = this.config.data.action;
        this.verificationDetail = this.config.data.verificationDetail;

    }

    ngOnInit() {
        this.minDate = this.convertToDate(this.verificationDetail.orderDate);
        this.initializeConfirmForm();
        this.initializeLocale();
         this.action==='APPROVE' ? this.setTitle("APPROVAL_CONFIRMATION") : this.setTitle("REJECTION_CONFIRMATION");
    }

    setTitle(title: string){
        this.translateService.get(title).subscribe((translatedTitle) => {
            this.pageTitle=translatedTitle
        });
    }

    initializeConfirmForm() {
        this.confirmForm = this.fb.group({
            notes: [''],
            paymentDate: [null, [Validators.required]],
            confirmAction: [null, [Validators.required]],
        });
    }

    confirmClicked() {
        this.verificationsService
            .verifyPayment(
                mapToVerifyPayment(
                    this.verificationDetail,
                    this.action,
                    this.confirmForm
                )
            )
            .subscribe({
                next: (value) => {
                    this.showSuccessToast('Payment verification successful');
                    this.ref.close();
                    setTimeout(() => {
                        this.router.navigate(['/home/payment-verifications']);
                    }, 1000);
                },
                error: (err) => {
                    this.showErrorToast(err.message);
                    this.ref.close();
                },
            });
    }

    showSuccessToast(message: string) {
        this.translateService.get(['Success', message]).subscribe(translations => {
            this.messageService.add({
                severity: 'success',
                summary: translations['Success'],
                life: 2000,
                detail: translations.get(message),
                key: 'tc',
            });
        })
    }

    showErrorToast(error: string) {
        this.translateService.get(['Error', error]).subscribe(translations => {
            this.messageService.add({
                severity: 'error',
                summary: translations['Error'],
                life: 2000,
                detail: translations.get(error),
                key: 'tc',
            });
        })
    }

    convertToDate(value: string): Date {
        return new Date(value);
    }
}
